import React, { useEffect, useState } from 'react';
import { InlineWidget } from 'react-calendly';
import { api } from '../lib/api';
import { Calendar } from 'lucide-react';

export default function CalendlyEmbed() {
  const [cfg, setCfg] = useState(null);
  useEffect(() => {
    api.get('/calendly/config').then(r => setCfg(r.data)).catch(() => setCfg({ enabled: false }));
  }, []);
  if (!cfg) return null;
  if (!cfg.enabled) {
    return (
      <div className="border border-stilo-ink/10 bg-stilo-beige p-6" data-testid="calendly-pending">
        <div className="flex items-start gap-3">
          <Calendar className="w-5 h-5 text-stilo-gold mt-0.5" strokeWidth={1.5} />
          <div>
            <p className="font-serif text-2xl">Pendiente de programar</p>
            <p className="text-stilo-ink2 mt-2 text-sm">El estudio te enviará el enlace para reservar fecha y hora en breve. También aparecerá en tu hilo de la asesoría.</p>
          </div>
        </div>
      </div>
    );
  }
  return (
    <div className="border border-stilo-ink/10 bg-white" data-testid="calendly-embed">
      <p className="overline px-6 pt-6">Reserva fecha y hora</p>
      <InlineWidget
        url={cfg.url}
        styles={{ height: '720px', width: '100%' }}
        prefill={{ email: cfg.prefill.email, name: cfg.prefill.name }}
        pageSettings={{
          backgroundColor: 'fcfaf5',
          primaryColor: 'b78e58',
          textColor: '2d2521',
          hideEventTypeDetails: false,
          hideLandingPageDetails: false,
        }}
      />
    </div>
  );
}
